import { call, put, all, takeEvery, select } from "redux-saga/effects";

import { staffActions } from '../slice/staffSlice'
import { getAllStaffApi, createStaffApi, updateStaffApi, removeStaffApi, getAllStaffSelectApi } from 'services/authServices'
import { staffSelector } from 'redux/selector'

function* handleGetStaff(action) {
    try {
        const res = yield call(getAllStaffApi, action.payload.query, action.payload.currentPage, action.payload.permission)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(staffActions.getStaffSuccess({ data: response.data, totalPage: response.totalPage, totalItem: response.totalItem }))
            }
            else {
                yield put(staffActions.getStaffFailed())
            }
        }
        else {
            yield put(staffActions.getStaffFailed())
        }
    } catch (error) {
        yield put(staffActions.getStaffFailed())
    }
}

function* handleGetAllStaff() {
    try {
        const res = yield call(getAllStaffSelectApi)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(staffActions.getAllStaffSuccess({ data: response.data }))
            }
            else {
                yield put(staffActions.getAllStaffFailed())
            }
        }
        else {
            yield put(staffActions.getAllStaffFailed())
        }
    } catch (error) {
        yield put(staffActions.getAllStaffFailed())
    }
}



function* handleCreateStaff(action) {
    try {
        const res = yield call(createStaffApi, action.payload.values)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(staffActions.addStaffSuccess())
                action.payload.ShowToast('success', 'Thêm tài khoản thành công!')
                action.payload.hidden()
                action.payload.handleSetDefaultForm()
                yield put(staffActions.getStaff({ query: action.payload.querySearch, currentPage: action.payload.currentPage, permission: action.payload.permission, }))
            } else {
                yield put(staffActions.addStaffFailed())
                action.payload.setFieldError(response.data[0], response.data[1])
                action.payload.ShowToast('error', 'Thêm tài khoản thất bại, vui lòng thử lại sau!')

            }
        }
        else {
            yield put(staffActions.addStaffFailed())
            action.payload.ShowToast('error', 'Thêm tài khoản thất bại, vui lòng thử lại sau!')
        }
    } catch (error) {
        yield put(staffActions.addStaffFailed())
        action.payload.ShowToast('error', 'Thêm tài khoản thất bại, vui lòng thử lại sau!')
    }
}


function* handleUpdateStaff(action) {
    try {
        const res = yield call(updateStaffApi, action.payload.values.account_id, action.payload.values)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(staffActions.updateStaffSuccess())
                action.payload.ShowToast('success', 'Cập nhật tài khoản thành công!')
                action.payload.hidden()
                action.payload.handleSetDefaultForm()
                yield put(staffActions.getStaff({ query: action.payload.querySearch, currentPage: action.payload.currentPage, permission: action.payload.permission, }))
            } else {
                yield put(staffActions.updateStaffFailed())
                action.payload.setFieldError(response.data[0], response.data[1])
                action.payload.ShowToast('error', 'Cập nhật tài khoản thất bại, vui lòng thử lại sau!')

            }
        }
        else {
            yield put(staffActions.updateStaffFailed())
            action.payload.ShowToast('error', 'Cập nhật tài khoản thất bại, vui lòng thử lại sau!')
        }
    } catch (error) {
        yield put(staffActions.updateStaffFailed())
        action.payload.ShowToast('error', 'Cập nhật tài khoản thất bại, vui lòng thử lại sau!')
    }
}



function* handleRemoveStaff(action) {
    try {
        const res = yield call(removeStaffApi, action.payload.id)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(staffActions.removeStaffSuccess())
                const staffState = yield select(staffSelector)
                let totalPage = staffState.totalPage
                if (staffState.staffList.length === 1) {
                    totalPage = totalPage - 1
                    yield put(staffActions.setTotalPage(totalPage))
                    action.payload.setCurrentPage(action.payload.currentPage - 1)
                    yield History.navigate(`/admin/staff?page=${action.payload.currentPage - 1}`);
                }
                action.payload.ShowToast("success", 'Xóa tài khoản thành công!')
                yield put(staffActions.getStaff({ query: action.payload.querySearch, currentPage: action.payload.currentPage, permission: action.payload.permission, }))


            } else {
                yield put(staffActions.removeStaffFailed())
                action.payload.ShowToast('error', `Xóa tài khoản thất bại, tài khoản đang được sử dụng hoặc có lỗi xảy ra, vui lòng thử lại sau!`)
            }
        }
        else {
            yield put(staffActions.removeStaffFailed())
            action.payload.ShowToast('error', `Xóa tài khoản thất bại, tài khoản đang được sử dụng hoặc có lỗi xảy ra, vui lòng thử lại sau!`)
        }
    } catch (error) {
        yield put(staffActions.removeStaffFailed())
        action.payload.ShowToast('error', `Xóa tài khoản thất bại, tài khoản đang được sử dụng hoặc có lỗi xảy ra, vui lòng thử lại sau!`)
    }
}


export default function* staffSaga() {
    yield all(
        [
            takeEvery(staffActions.getStaff.type, handleGetStaff),
            takeEvery(staffActions.addStaff.type, handleCreateStaff),
            takeEvery(staffActions.updateStaff.type, handleUpdateStaff),
            takeEvery(staffActions.removeStaff.type, handleRemoveStaff),
            takeEvery(staffActions.getAllStaff.type, handleGetAllStaff),
        ]
    )
}
